/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { AssignProjectParameterValuesComponent } from '../../components/assign-project-parameter-values/assign-project-parameter-values.component';
import { SysquePopupConfig } from '../../models/sysque-popup-config';
import { PopupDialog } from '../popup-dialog.interface';

export class AssignProjectDialog implements PopupDialog {
  create(sysquePopupConfig: SysquePopupConfig): any {
    sysquePopupConfig.component = AssignProjectParameterValuesComponent;
    sysquePopupConfig.data = null;
    sysquePopupConfig.height = 600;
    sysquePopupConfig.width = 520;
    sysquePopupConfig.componentTitle = 'Assign Project Parameter Values';
  }
}
